import TrendingProducts from "components/dashboardComponents/trendingProducts";
import useAllProductsData from "hook/useAllProductsData";
import CardDesign from "../components/cardDesign";
import { FaStar, FaTag } from "react-icons/fa";
import { useSettings } from "context/SettingsContext";
import { t } from "context/translations";
import ScrollToTopButton from "components/ScrollToTopButton";
import newProductBanner from "../images/newProductBanner.webp";

const NewProductsFullPage = () => {
    const { allProducts, loading, error } = useAllProductsData();
    const { theme, language } = useSettings();
    const isDark = theme === "dark";

    return (
        <div className=" flex flex-col min-h-[100dvh]">
            <div className="relative rounded-md mb-5 md:max-w-7xl mx-auto select-none">
                {/* ✅ Data */}
                {!loading && !error && allProducts.length > 0 && (
                    <div className="">
                        <section
                            className={`overflow-hidden mb-5 ${isDark ? "bg-zinc-900" : "bg-slate-900"}  text-white shadow-lg sm:px-10`}
                        >
                            <div className="relative">
                                <div className="absolute inset-0">
                                    <img
                                        src={newProductBanner}
                                        alt="New arrivals banner"
                                        className="h-full w-full object-cover opacity-50"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-r from-emerald-950/95 via-slate-900/85 to-cyan-900/70" />
                                </div>
                            </div>
                            <div className="relative p-5 sm:p-7">
                                <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
                                    <div>
                                        <p className="inline-flex items-center gap-2 pb-2 text-xs font-semibold uppercase tracking-widest text-emerald-100">
                                            ✨ {t("freshArrival", language)}
                                        </p>
                                        <h1 className="text-2xl font-extrabold sm:text-3xl">
                                            {t("newProducts", language).toUpperCase()}
                                        </h1>
                                        <p className="mt-2 max-w-xl text-sm text-slate-200 sm:text-base">
                                            {t("newProductTitle", language)}
                                        </p>
                                    </div>
                                    <div className="flex flex-wrap items-center gap-2">
                    <span className="text-xs inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-2">
                      <FaStar />
                        {t("newArrivals", language)}
                    </span>
                                        <span
                                            className={`text-xs inline-flex items-center gap-2 rounded-full border border-white/15 ${isDark ? "bg-gray-100 text-white" : "bg-white text-slate-900"} px-3 py-2`}
                                        >
                      <FaTag />
                                            {t("justLanded", language)}
                    </span>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <CardDesign likeData={allProducts} />
                    </div>
                )}
            </div>
            <TrendingProducts />
            <ScrollToTopButton />
        </div>
    );
};

export default NewProductsFullPage;
